import { clusterBase } from '@/features/dashboard/config';
import type { Cluster } from '@/backends';
import { DASHBOARD_CONFIGS } from '@/features/dashboard/config';

/*
 * Backend options for the admin pages (runs / config): one entry per unique
 * DATA backend the reports resolve to, labelled by CLUSTER — not by joining
 * report names (a frozen report served from EU must not make "Brasil" look
 * like a live backend). After the BR/AH retirements every report resolves to
 * the EU cluster, so this typically yields a single option.
 */
const CLUSTER_LABELS: Record<Cluster, string> = {
  br: 'Brazil cluster',
  eu: 'EU cluster',
  ah: 'AH cluster',
};

function clusterLabelFor(baseUrl: string): string {
  for (const c of Object.keys(CLUSTER_LABELS) as Cluster[]) {
    if (clusterBase(c) === baseUrl) return CLUSTER_LABELS[c];
  }
  return baseUrl; // unknown backend — show the URL rather than guessing
}

export function backendOptions(): Array<{ baseUrl: string; label: string }> {
  const urls = [...new Set(DASHBOARD_CONFIGS.map((c) => c.apiBaseUrl))];
  return urls.map((baseUrl) => ({ baseUrl, label: clusterLabelFor(baseUrl) }));
}
